import React, { useEffect, useState } from 'react'
import XButton from '../XButton'
import { BUTTON_SIZE, BUTTON_STYLE_TYPE } from '../../styles/constants'
import styles from './style.module.scss'
import { useTranslation } from '../../../i18n'
import { Link } from 'rebass'

export interface XNavProps {
    categories: any
    active?: number
}

const XNav = (props: XNavProps) => {
    const { t } = useTranslation(window.LANG_NS)
    const { categories } = props
    const [activeCategory, setActiveCategory] = useState(props.active !== -1 ? props.active : 0)

    const categoryHandler = (index: number) => {
        setActiveCategory(index)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const currentPath = window.location.pathname
            const activeIndex = categories.findIndex((category: any) => {
                if (category.url !== '/') {
                    return currentPath.includes(category.url)
                }
            })

            if (activeIndex !== -1) {
                setActiveCategory(activeIndex)
            } else {
                setActiveCategory(0)
            }
        }
    }, [categories])

    return (
        <div className={styles.xNAV__container}>
            {categories.map((category: any, index: number) => {
                return (
                    <Link
                        key={index}
                        href={`${
                            window.PERSON?.applicationDetails[0].program?.urlFragment || window.PROGRAM.urlFragment
                        }/${category.url}`}
                        target="_self"
                        sx={{
                            all: 'unset',
                            width: '100%',
                            justifyContent: 'center',
                            textAlign: 'center',
                        }}
                        className={styles.xNAV__button_container}
                    >
                        <XButton
                            styleType={activeCategory === index ? BUTTON_STYLE_TYPE.NAV : BUTTON_STYLE_TYPE.DISABLED}
                            size={BUTTON_SIZE.SMALL}
                            onClick={() => {
                                categoryHandler(index)
                            }}
                        >
                            {category.label}
                        </XButton>
                        {activeCategory === index ? (
                            <div className={styles.xNAV__button_container__active_line}></div>
                        ) : (
                            <div className={styles.xNAV__line} />
                        )}
                    </Link>
                )
            })}
        </div>
    )
}

export default XNav
